import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL

let token = process.env.REACT_APP_TOKEN

export const api = axios.create({

    baseURL: baseURL,  

    headers: {

            'Authorization': 'Bearer ' + token,

            'Content-type': 'application/json',

    }

});